import React from 'react';

export const Loading = () => {
  return (
    <div className="w-full h-screen flex justify-center items-center text-center">
      <h1 className='text-4xl text-center animate-pulse'>Loading</h1>
    </div>
  );
};
